export default "__VITE_ASSET__CdPwkSVg__"